var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.29 39.29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.29 39.29a1 1 0 01-.7-.29L19.65 21.06 1.71 39a1 1 0 01-1.42 0 1 1 0 010-1.41l17.94-17.94L.29 1.71A1 1 0 011.71.29l17.94 17.94L37.59.29a1 1 0 011.41 0 1 1 0 010 1.42L21.06 19.65 39 37.59A1 1 0 0139 39a1 1 0 01-.71.29z",
    "data-name": "Layer 1"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOS4yOSAzOS4yOSI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iY2xvc2UiPjxwYXRoIGQ9Ik0zOC4yOSwzOS4yOWExLDEsMCwwLDEtLjctLjI5TDE5LjY1LDIxLjA2LDEuNzEsMzlBMSwxLDAsMCwxLC4yOSwzOWExLDEsMCwwLDEsMC0xLjQxTDE4LjIzLDE5LjY1LjI5LDEuNzFBMSwxLDAsMCwxLDEuNzEuMjlMMTkuNjUsMTguMjMsMzcuNTkuMjlBMSwxLDAsMCwxLDM5LC4yOWExLDEsMCwwLDEsMCwxLjQyTDIxLjA2LDE5LjY1LDM5LDM3LjU5QTEsMSwwLDAsMSwzOSwzOSwxLDEsMCwwLDEsMzguMjksMzkuMjlaIi8+PC9nPjwvZz48L2c+PC9zdmc+";
export { SvgClose as ReactComponent };